var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3331 17.3335C13.9057 18.099 14.6363 18.7324 15.4752 19.1907C16.3141 19.649 17.2418 19.9216 18.1953 19.9899C19.1488 20.0582 20.1059 19.9206 21.0016 19.5865C21.8973 19.2524 22.7106 18.7295 23.3864 18.0535L27.3864 14.0535C28.6008 12.7961 29.2728 11.1121 29.2576 9.36411C29.2424 7.61613 28.5413 5.94405 27.3052 4.70799C26.0692 3.47194 24.3971 2.77081 22.6491 2.75562C20.9011 2.74043 19.2171 3.4124 17.9598 4.62678L15.6664 6.90678M18.6664 14.6668C18.0938 13.9013 17.3633 13.2679 16.5244 12.8095C15.6855 12.3512 14.7578 12.0786 13.8042 12.0103C12.8507 11.942 11.8937 12.0796 10.998 12.4137C10.1023 12.7479 9.28896 13.2707 8.61311 13.9468L4.61311 17.9468C3.39872 19.2041 2.72676 20.8881 2.74195 22.6361C2.75714 24.3841 3.45827 26.0562 4.69432 27.2922C5.93038 28.5283 7.60246 29.2294 9.35044 29.2446C11.0984 29.2598 12.7824 28.5878 14.0398 27.3735L16.3198 25.0935",
    stroke: "url(#paint0_linear_2494_14487)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2494_14487",
    x1: 15.9998,
    y1: 2.75537,
    x2: 15.9998,
    y2: 29.2449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0152C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176CD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.fd48aeb549494fac8a1d87e13d32ef4e.svg";
export { ForwardRef as ReactComponent };